module.exports = __webpack_public_path__ + "static/media/editCircle.b361a54b.svg";